import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { EmptyState } from '@/components/States';
import { ToastHost } from '@/components/ToastHost';
import { Button } from '@/ui';

import type { QueryClient } from '@tanstack/react-query';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return (
    <>
      <Outlet />
      <ToastHost />
      {import.meta.env.DEV ? <TanStackRouterDevtools position="bottom-right" /> : null}
    </>
  );
}

function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <EmptyState
        icon="search-x"
        title="This page does not exist"
        description="The link may be old, or the page moved."
        action={
          <Link to="/">
            <Button size="sm" variant="ghost">
              Go to the dashboard
            </Button>
          </Link>
        }
      />
    </div>
  );
}
